/**
 * @format
 */

export const DEFAULT_BACK_BUTTON_WARNING_BOOK_APPOINTMENT_VIEW =
	'Are you sure you want to go back? Doing so will cancel this reservation, and you will be directed back to availability results.';

export const DEFAULT_BACK_BUTTON_WARNING_DECISION_SUPPORT_VIEW =
	'Are you sure you want to go back? Doing so will take you back to the patient search screen.';
